// extracted by mini-css-extract-plugin
module.exports = {"container":"CardImageFooter_container__Irb1y","hide":"CardImageFooter_hide__YRgkr"};